<div [ngClass]="{ disable: loadingTableData }" class="wrapper table-edge-margin" *ngLet="!!(loadingDataTable$ | async) as loadingTableData">
  <ng-container *ngLet="breakPointObserve$ | async as screenRes">
    <ng-container *ngLet="catalogFilter$ | async as catalogFilter">
      <ng-container *ngIf="screenRes > 768; else mobileButtons">
        <ng-container *ngLet="categoriesFilterObserver$ | async">
          <app-multi-select-with-input
            class="mr16"
            *ngIf="categoriesOptions$ | async as options"
            [formControl]="categoriesFilterControl"
            [floatingTitle]="'DATA.TABLE_FILTER.CATEGORIES'"
            [dropdownWidth]="636"
            [options]="options"
          >
          </app-multi-select-with-input>
        </ng-container>

        <ng-container *ngLet="providersFilterObserver$ | async">
          <app-multi-select-with-input
            *ngIf="providersOptions$ | async as options"
            [formControl]="providersFilterControl"
            [floatingTitle]="'DATA.TABLE_FILTER.SUPPLIERS'"
            [dropdownWidth]="530"
            [maxDropdownHeight]="452"
            [showChooseAllBtn]="false"
            [options]="options"
          >
          </app-multi-select-with-input>
        </ng-container>
      </ng-container>

      <ng-template #mobileButtons>
        <button
          class="btn-empty mobile-button"
          [class.has-filters]="hasMobileCategoryOIVFilters$ | async"
          (click)="isOpenCategoryFilter = !isOpenCategoryFilter"
        >
          <svg [icon]="icons.Interests" class="svg24 dark-gray-color" />
        </button>
      </ng-template>

      <ng-container *ngIf="isOpenCategoryFilter">
        <div class="category-filter-mobile mobile-bottom-show-up">
          <div class="filter-mobile-header">
            <button class="btn-empty closer" (click)="closeCatalogProviderFilterSubmit()">
              <svg [icon]="icons.Close" class="svg24 dark-gray-color" />
            </button>
            <p class="h3 bold mb16">{{ 'DATA.TABLE_FILTER.CHOOSING_CATEGORY_OR_DATA_PROVIDER' | translate }}</p>
            <ul class="filter-type">
              <li class="filter-type-item">
                <button
                  [class.active]="!isOpenProvidersFilter"
                  class="btn-empty caption-1 dark-gray-color filter-type-selector"
                  (click)="isOpenProvidersFilter = false"
                >
                  {{ 'DATA.TABLE_FILTER.CATEGORIES' | translate }}
                </button>
              </li>
              <li class="filter-type-item">
                <button
                  [class.active]="isOpenProvidersFilter"
                  class="btn-empty caption-1 dark-gray-color filter-type-selector"
                  (click)="isOpenProvidersFilter = true"
                >
                  {{ 'DATA.TABLE_FILTER.SUPPLIERS' | translate }}
                </button>
              </li>
            </ul>
          </div>

          <div class="list-wrapper">
            <ng-container *ngLet="categoriesFilterObserver$ | async">
              <app-multi-select-with-input
                [class.hidden]="isOpenProvidersFilter"
                [flatLayout]="true"
                [emitValue]="false"
                [isOpen]="true"
                *ngIf="categoriesOptions$ | async as options"
                [formControl]="categoriesFilterControl"
                [floatingTitle]="'DATA.TABLE_FILTER.CATEGORIES' | translate"
                [dropdownWidth]="636"
                [options]="options"
              >
              </app-multi-select-with-input>
            </ng-container>

            <ng-container *ngLet="providersFilterObserver$ | async">
              <app-multi-select-with-input
                [class.hidden]="!isOpenProvidersFilter"
                [flatLayout]="true"
                [emitValue]="false"
                [isOpen]="true"
                *ngIf="providersOptions$ | async as options"
                [formControl]="providersFilterControl"
                [floatingTitle]="'DATA.TABLE_FILTER.SUPPLIERS' | translate"
                [dropdownWidth]="530"
                [maxDropdownHeight]="isMobile ? 1000 : 452"
                [optionHeight]="80"
                [showChooseAllBtn]="false"
                [options]="options"
              >
              </app-multi-select-with-input>
            </ng-container>
          </div>

          <div class="button-footer">
            <div class="container-button">
              <button class="btn-secondary medium mr12" (click)="closeCatalogProviderFilterClear()" type="button">
                {{ 'OTHER.RESET_ALL' | translate }}
              </button>
              <button class="btn-primary medium" (click)="closeCatalogProviderFilterSubmit()" type="submit">{{ 'OTHER.APPLY' | translate }}</button>
            </div>
          </div>
        </div>
        <div class="backdrop" (click)="isOpenCategoryFilter = false"></div>
      </ng-container>
      <div class="vl"></div>
      <mat-button-toggle-group
        class="toggle-group"
        *ngIf="screenRes > 1650; else onlyFavorites"
        [formControl]="newFavoriteRecommendedToggle"
        (click)="onNewFavoriteRecommendedChange()"
      >
        <mat-button-toggle class="all-button" value="all">
          <span class="caption-2">{{ 'DATA.TABLE_FILTER.ALL' | translate }}</span>
        </mat-button-toggle>
        <mat-button-toggle
          [matTooltip]="catalogFilter?.booleanFilters?.datasetType === 'dynamic' ? ('OTHER.NOT_AVAILABLE_DYNAMIC_CATALOG' | translate) : ''"
          [disabled]="catalogFilter?.booleanFilters?.datasetType === 'dynamic'"
          class="new-button"
          value="new"
        >
          <span class="caption-2">{{ 'DATA.TABLE_FILTER.NEW' | translate }}</span>
        </mat-button-toggle>
        <mat-button-toggle
          [matTooltip]="catalogFilter?.booleanFilters?.datasetType === 'dynamic' ? ('OTHER.NOT_AVAILABLE_DYNAMIC_CATALOG' | translate) : ''"
          [disabled]="catalogFilter?.booleanFilters?.datasetType === 'dynamic'"
          class="recommended-button"
          value="recommended"
        >
          <span class="caption-2">{{ 'DATA.TABLE_FILTER.RECOMMENDED' | translate }}</span>
        </mat-button-toggle>
        <mat-button-toggle class="favorites-button" value="favorites">
          <svg [icon]="icons.BookmarkFill" class="svg20 mr4 inactive-color" />
          <span class="caption-2">{{ 'DATA.TABLE_FILTER.FAVORITES' | translate }}</span>
        </mat-button-toggle>
      </mat-button-toggle-group>

      <ng-template #onlyFavorites>
        <!-- <label class="favorite-button mobile-button icon-btn">
          <input type="checkbox" class="visually-hidden checkbox" (change)="onMobileFavorites($event)" #mobileFav />
          <span class="circle"></span>
          <svg [icon]="icons.Bookmark" class="svg24 dark-gray-color icon" />
        </label>
        <div class="vl"></div>-->
      </ng-template>

      <ng-container *ngIf="screenRes > 768; else mobileFilterBtn">
        <button
          class="btn-empty filter-dropdown-btn"
          [class.active]="isOpenFilter"
          cdkOverlayOrigin
          #filterTrigger="cdkOverlayOrigin"
          (click)="isOpenFilter = !isOpenFilter"
        >
          <svg [icon]="icons.MoreVert" class="svg24 filter-btn-text" />
          <span class="more-text filter-btn-text">{{ 'DATA.TABLE_FILTER.MORE' | translate }}</span>
        </button>

        <ng-container *ngLet="hasFilters$ | async as hasFilter">
          <button class="btn-empty icon-btn center clear-filters-btn" [disabled]="!hasFilter" [class.active]="hasFilter" (click)="clearFilters()">
            <span class="interactive"></span>
            <svg [icon]="icons.Filter" class="svg24 filter clear-filter-icon"></svg>
            <svg [icon]="icons.CloseRound" class="svg14 close-round-icon"></svg>
          </button>
        </ng-container>
        <ng-template
          cdkConnectedOverlay
          [cdkConnectedOverlayPositions]="filterOverlayPosition"
          [cdkConnectedOverlayHasBackdrop]="true"
          [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
          [cdkConnectedOverlayOrigin]="filterTrigger"
          [cdkConnectedOverlayOpen]="isOpenFilter"
          (backdropClick)="isOpenFilter = !isOpenFilter"
        >
          <app-catalog-table-filter (close)="isOpenFilter = !$event"></app-catalog-table-filter>
        </ng-template>
      </ng-container>

      <ng-template #mobileFilterBtn>
        <button
          class="btn-empty icon-btn filter-btn center mobile-filter-btn"
          [class.has-filters]="hasMobileFilters$ | async"
          [class.active]="isOpenFilter"
          (click)="isOpenFilter = !isOpenFilter"
        >
          <app-hoverable-svg [icon]="icons.Filter" class="svg22 filter"></app-hoverable-svg>
        </button>

        <ng-container *ngIf="isOpenFilter">
          <div class="category-filter-mobile mobile-bottom-show-up filter-padding">
            <span class="h3 dark-color">{{ 'DATA.TABLE_FILTER.FILTERS' | translate }}</span>
            <button class="btn-empty closer" (click)="isOpenFilter = false">
              <svg [icon]="icons.Close" class="svg24 dark-gray-color" />
            </button>
            <app-catalog-table-filter [isMobile]="true" [filterContainer]="filterContainer" (close)="isOpenFilter = false"></app-catalog-table-filter>
          </div>
          <div class="backdrop" (click)="isOpenFilter = false"></div>
        </ng-container>
      </ng-template>

      <div class="vl ml2"></div>

      <span class="h4 text-count" *ngLet="countCatalogs$ | async as catalogCount">
        {{ 'DATA.TABLE_FILTER.TOTAL' | translate }} {{ catalogCount }}
        {{ catalogCount | dw: 'DATA.TABLE_FILTER.SET':'DATA.TABLE_FILTER.SET_GENITIVE':'DATA.TABLE_FILTER.SETS' | translate }}
      </span>

      <div class="search-input">
        <ng-container *ngIf="screenRes > 400; else inputShower">
          <ng-container *ngTemplateOutlet="searchInput; context: { hideGlobalSearch: false }"></ng-container>
        </ng-container>

        <ng-template #inputShower>
          <button
            *ngIf="!showMobileSearch && !catalogFilter?.searchString; else mobileSearch"
            class="btn-empty"
            (click)="isMobileInputShowed = !isMobileInputShowed"
          >
            <svg class="svg24 dark-gray-color" [icon]="icons.Search" />
          </button>

          <ng-template #mobileSearch>
            <ng-container *ngTemplateOutlet="searchInput; context: { hideGlobalSearch: true }"></ng-container>
          </ng-template>
        </ng-template>

        <ng-container *ngIf="isMobileInputShowed && isMobile && isMobileSearch">
          <div class="floating-input">
            <ng-container *ngTemplateOutlet="searchInput; context: { hideGlobalSearch: false }"></ng-container>
          </div>
        </ng-container>

        <ng-template #searchInput let-hideGlobalSearch="hideGlobalSearch">
          <app-search-input
            (inputClickEvent)="isMobileInputShowed = true"
            [hideGlobalSearchLink]="hideGlobalSearch"
            [searchString]="catalogFilter?.searchString ?? ''"
            [disabledInput]="loadingTableData"
            (startSearch)="startSearch($event)"
            (searchTextChange)="searchTextChange($event)"
            (clear)="showMobileSearch = false"
          ></app-search-input>
        </ng-template>
      </div>
      <app-ordering></app-ordering>
      <app-registry-export></app-registry-export>
    </ng-container>
  </ng-container>
</div>
